export default __webpack_public_path__ + "static/media/fleet-management.2c4ee892.svg";